module.exports = __webpack_public_path__ + "img/no_data.98c9e383.png";